// extracted by mini-css-extract-plugin
module.exports = {"copyright":"Copyright_copyright__tWIau","company":"Copyright_company__KksRy","companyText":"Copyright_companyText__Qn94m","copyrightText":"Copyright_copyrightText__p20LS"};